import { COGNITO_ACCESS_TOKEN_PATTERN_KEY, COGNITO_ID_TOKEN_PATTERN_KEY, COGNITO_LAST_USER_PATTERN_KEY } from 'api/http'
import { Amplify } from 'aws-amplify'

Amplify.configure({
	Auth: {
		region: process.env.NEXT_PUBLIC_COGNITO_AWS_REGION,
		userPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID,
		userPoolWebClientId: process.env.NEXT_PUBLIC_COGNITO_WEB_CLIENT_ID,
		storage: typeof localStorage !== 'undefined' ? localStorage : undefined,

		oauth: {
			domain: process.env.NEXT_PUBLIC_COGNITO_OAUTH_DOMAIN,
			scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
			redirectSignIn: process.env.NEXT_PUBLIC_COGNITO_OAUTH_REDIRECT_SIGNIN,
			redirectSignOut: process.env.NEXT_PUBLIC_COGNITO_OAUTH_REDIRECT_SIGNOUT,
			responseType: 'token',
			urlOpener: (url: string) => {
				if (url.includes('logout')) {
					window.location.href = url
					return
				}

				const left = (window.screen.width - 600) / 2
				const top = (window.screen.height - 549) / 2
				const windowProxy = window.open(
					url,
					'BlockSentry Auth',
					`resizable = yes, width=600,height=549,top=${top},left=${left}`
				)

				window.childAuthorized =
					window.childAuthorized ||
					(({
						idToken,
						accessToken,
						lastAuthUser,
					}: {
						idToken?: string
						accessToken?: string
						lastAuthUser?: string
					}) => {
						if (idToken && accessToken && lastAuthUser) {
							localStorage.setItem(COGNITO_ID_TOKEN_PATTERN_KEY.replace('{ACCOUNT}', lastAuthUser), idToken)
							localStorage.setItem(COGNITO_ACCESS_TOKEN_PATTERN_KEY.replace('{ACCOUNT}', lastAuthUser), accessToken)
							localStorage.setItem(COGNITO_LAST_USER_PATTERN_KEY, lastAuthUser)
						}
						window.location.reload()
						windowProxy?.close()
					})

				return Promise.resolve(windowProxy)
			},
		},
	},
	aws_appsync_graphqlEndpoint: process.env.NEXT_PUBLIC_APPSYNC_GRAPHQL_ENDPOINT,
	aws_appsync_region: process.env.NEXT_PUBLIC_AWS_REGION,
	aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
})
